import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { PaymentProduct } from '../../model/payment/PaymentCollectionRequest';

@Component({
  selector: 'app-add-fund-popup-v2',
  templateUrl: './add-fund-popup-v2.component.html',
  styleUrls: ['./add-fund-popup-v2.component.scss']
})
export class AddFundPopupV2Component implements OnInit {
  private matDialogRef: MatDialogRef<AddFundPopupV2Component>;
  private router: Router;
  data: DialogContainer;
  public topupAmount: number;
  public isVirtualAccountDiscriptionOpen: boolean = false;

  constructor(
    router: Router,
    matDialogRef: MatDialogRef<AddFundPopupV2Component>,
    @Inject(MAT_DIALOG_DATA) data: DialogContainer
  ) {
    this.matDialogRef = matDialogRef;
    this.router = router;
    this.data = data;
    console.log(this.data)
  }

  ngOnInit(): void {
  }

  public async onAddMoneyClick(topupAmount) {
    this.matDialogRef.close(true);
    console.log(topupAmount)
    await this.router.navigate(['payment/initiate'], { state: { topUpAmount: topupAmount, paymentProduct: this.data.paymentProduct } });
  }

  public isFormValid(isValidInputValue: boolean): boolean {
    return (isValidInputValue && this.topupAmount > 0);
  }

  public onClickVirtualAccountDiscriptionClose() {
    this.isVirtualAccountDiscriptionOpen = false;
  }

  public async onClickVirtualAccountDiscriptionOpen() {
    this.isVirtualAccountDiscriptionOpen = true;
    setTimeout(function () {
      const virtualAccountDiscriptionView = document.getElementById("virtualAccountDiscription");
      virtualAccountDiscriptionView.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 50);
  }

}

interface DialogContainer {
  dialogHeading: string,
  dialogSubHeading: string,
  bodyNotifySupportEmail: string,
  bodyNormalContent: string,
  bodyTitle: string,
  bodyEnterAmount: string,
  payButtonText: string,
  amountWaringText: string,
  tableHeading: string,
  paymentProduct: string,
  bankDetails: object,
  hideBankDetails: boolean
}
